var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationLogo3Bw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 131,
    viewBox: "0 0 151 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6031_824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3851 14.1484L0.92627 62.2165V129.678H69.9752L103.658 96.1976",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5764 82.761L119.155 0.583984",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6421 80.1824L150.237 0.583984",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6031_824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150.24,
    height: 130,
    fill: "white",
    transform: "translate(0.379883 0.210938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLogo3Bw);
export default __webpack_public_path__ + "static/media/illustration-logo-3-bw.c8ce8e1eee83b2240a11538a79e5f59c.svg";
export { ForwardRef as ReactComponent };